import React, { useState, useEffect } from 'react'
import CountUp from 'react-countup'
import OnVisible from 'react-on-visible'
import darkOrbit from '../../../images/roi/dark-orbit.svg'
import darkOrbit2 from '../../../images/roi/dark-orbit-2.svg'
import './styles.scss'

const PercentAnimation = ({ start, end, duration = 2, alternateBg, alt = "", id="" }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const circle = document.getElementById(id);
    const radius = circle.r.baseVal.value;
    const circumference = radius * 2 * Math.PI;
    circle.style.strokeDasharray = `${circumference} ${circumference}`;
    circle.style.strokeDashoffset = `${circumference}`;
  }, []);

  useEffect(() => {
    const circle = document.getElementById(id);
    const radius = circle.r.baseVal.value;
    const circumference = radius * 2 * Math.PI;
    if (isVisible) {
      const offset = circumference - end / 100 * circumference;
      circle.style.strokeDashoffset = offset;
    }
  }, [isVisible]);

  return (
    <OnVisible className="percent-animation" onChange={setIsVisible}>
      <div className="percent-animation-bg">
        <img src={alternateBg ? darkOrbit : darkOrbit2} alt="67% change fail rate below 15%" />
        <svg
         class="percent-animation-ring"
         width="174"
         height="174">
        <circle
          class="percent-animation-ring-circle"
          stroke="#0E1932"
          stroke-width="4"
          fill="transparent"
          r="79"
          cx="87"
          cy="87"
        />
        <circle
          id={id}
          class="percent-animation-ring-circle"
          stroke="white"
          stroke-width="5"
          fill="transparent"
          r="79"
          cx="87"
          cy="87"
          style={{ transitionDuration: `${duration}s` }}
        />
      </svg>
      </div>
      <div className="percent-animation-countup">
        {isVisible && <CountUp start={start} end={end} duration={duration} />}
        <sup>%</sup>
      </div>
    </OnVisible>
  );
};

export default PercentAnimation;
